import connectionProxy from './connectionProxy'

// página pública do QR Code de FDS da área: o token substitui o id da área
export const getAreaFds = token =>
  connectionProxy.http.get(`/fds_por_area/${token}`)



// WEBPACK FOOTER //
// ./src/api/areaFds.js